import Permission from "../../permission";

export default class PermissionCommand {
  public id?: string;
  public resource?: string;
  public granteeUserId?: string;
  public parentId?: string;
  public note?: string;

  constructor(permission: Permission) {
    this.id = permission.id?.toString();
    this.resource = permission.resource?.toJSONString();
    this.granteeUserId = permission.granteeUserId?.toString();
    this.parentId = permission.parentId?.toString();
    this.note = permission.note;
  }
}
